<form [formGroup]="form">
  <div class="row">
      <div class="col">
          <div>
            <label class="ms-2 me-2 col-form-label"><span class="text-center">{{ 'Start Time' | messageTranslate }}</span></label>
          </div>
          <ngb-timepicker
                  formControlName="startTime"
                  [spinners]="!readonly"
                  [readonlyInputs]="readonly"/>
      </div>
      <div class="col">
          <div>
            <label class="ms-2 me-2 col-form-label"><span class="text-center">{{ 'End Time' | messageTranslate }}</span></label>
          </div>
          <ngb-timepicker
                  formControlName="endTime"
                  [spinners]="!readonly"
                  [readonlyInputs]="readonly"/>
      </div>
  </div>

  <div>
    @if (!readonly) {
      <div class="ms-2 me-2">
        <ui-switch formControlName="excludeWeekends" [checked]="false" size="small"/>
        <span class="align-top">{{ 'Exclude Weekends' | messageTranslate }}</span>
      </div>
    } @else {
      <div class="ms-2 me-2 mt-2">
        {{ model.excludeWeekends ? ('Exclude Weekends' | messageTranslate) : ('Include Weekends' | messageTranslate) }}
      </div>
    }
  </div>

  @if (isTouched('startTime')) {
    <div>
      @if (form.get('startTime').hasError('invalidTime')) {
        <div class="invalid-feedback d-flex">
          {{ 'Start time is not valid' | messageTranslate }}
        </div>
      }
    </div>
  }
  @if (isTouched('endTime')) {
    <div>
      @if (form.get('endTime').hasError('invalidTime')) {
        <div class="invalid-feedback d-flex">
          {{ 'End time is not valid' | messageTranslate }}
        </div>
      }
    </div>
  }
  @if (isFormTouched()) {
    <div>
      @if (form.hasError('endBeforeStart')) {
        <div class="invalid-feedback d-flex">
          {{ 'End time cannot be before Start time' | messageTranslate }}
        </div>
      }
    </div>
  }
</form>
